var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 10,
    fill: "#E1FFBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4183 22.8714C32.4183 28.1442 28.1438 32.4188 22.8709 32.4188C17.5981 32.4188 13.3235 28.1442 13.3235 22.8714C13.3235 17.5985 17.5981 13.324 22.8709 13.324C28.1438 13.324 32.4183 17.5985 32.4183 22.8714Z",
    fill: "#79C943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.988 18.1647L21.6563 23.4964C20.7748 22.6154 19.8906 21.7309 19.0107 20.8526L16.8436 23.0223C19.8399 26.021 22.813 28.9947 25.7844 31.9657C29.4204 30.8015 32.1083 27.5184 32.3931 23.5688C30.591 21.7671 28.7893 19.9663 26.9877 18.1647",
    fill: "black",
    fillOpacity: 0.235
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.8787C16.8579 11.8787 11.8786 16.858 11.8786 23.0001C11.8786 29.1421 16.8579 34.1215 23 34.1215C29.1421 34.1215 34.1214 29.1421 34.1214 23.0001C34.1214 16.858 29.1421 11.8787 23 11.8787ZM23.385 13.8383C28.6578 13.8383 32.9319 18.1124 32.9319 23.3852C32.9319 28.6581 28.6578 32.9322 23.385 32.9322C18.1121 32.9322 13.8367 28.6581 13.8367 23.3852C13.8367 18.1124 18.1121 13.8383 23.385 13.8383Z",
    fill: "black",
    fillOpacity: 0.067
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12.0283C16.9403 12.0283 12.0282 16.9405 12.0282 23.0001C12.0282 29.0598 16.9403 33.9719 23 33.9719C29.0596 33.9719 33.9718 29.0598 33.9718 23.0001C33.9718 16.9405 29.0596 12.0283 23 12.0283ZM23.2566 13.7099C28.5295 13.7099 32.8036 17.984 32.8036 23.2568C32.8036 28.5297 28.5295 32.8038 23.2566 32.8038C17.9838 32.8038 13.7084 28.5297 13.7084 23.2568C13.7084 17.984 17.9838 13.7099 23.2566 13.7099Z",
    fill: "black",
    fillOpacity: 0.129
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12.2C17.035 12.2 12.1996 17.0354 12.1996 23.0004C12.1996 28.9654 17.035 33.8008 23 33.8008C28.965 33.8008 33.8004 28.9654 33.8004 23.0004C33.8004 17.0354 28.965 12.2 23 12.2ZM23.1283 13.5821C28.4012 13.5821 32.6753 17.8562 32.6753 23.1291C32.6753 28.4019 28.4012 32.676 23.1283 32.676C17.8555 32.676 13.58 28.4019 13.58 23.1291C13.58 17.8562 17.8555 13.5821 23.1283 13.5821Z",
    fill: "black",
    fillOpacity: 0.129
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8709 12.1779C16.9648 12.1779 12.1773 16.9657 12.1773 22.8714C12.1773 28.7775 16.9652 33.565 22.8709 33.565C28.777 33.565 33.5645 28.7771 33.5645 22.8714C33.5645 16.9653 28.7766 12.1779 22.8709 12.1779ZM22.8709 13.3248C28.1438 13.3248 32.4179 17.5989 32.4179 22.8717C32.4179 28.1446 28.1438 32.4187 22.8709 32.4187C17.598 32.4187 13.3226 28.1446 13.3226 22.8717C13.3226 17.5989 17.598 13.3248 22.8709 13.3248Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9884 18.1647L21.6554 23.4977L19.0115 20.8521L16.8431 23.0219L19.4869 25.6662L21.6554 27.8359L23.8251 25.6662L29.1568 20.3344L26.9884 18.1647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.4ea28cba434ed1554b2a78a6b7465593.svg";
export { ForwardRef as ReactComponent };